import * as requestFromServer from "./SystemLogsCrud";
import { callTypes, systemLogSlice } from "./SystemLogsSlice";

const {actions} = systemLogSlice;

export const getSystemLogs = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getSystemLogs(queryParams)
    .then(response => {
      dispatch(actions.systemLogsFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getException = id => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getException(id)
    .then(response => {
      dispatch(actions.exceptionFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const cleanExceptionState = () => dispatch => {
  dispatch(actions.exceptionStateCleaned());
};

export const cleanSystemLogsState = () => dispatch => {
  dispatch(actions.systemLogsStateCleaned());
};